import { dialogContentInformations } from "../interfaces/dialogInformations";
import { infoToolTipCardOptions } from "../interfaces/infoToolTipCardOptions";

export const scannerInputToolTipErrorInformationsCard: infoToolTipCardOptions = {
  cardTitle: "Leitura inválida",
  cardSubtitle: "Valores aceitos: ",
  cardlistItems: [
    {
      text: "Código ou Código de barras",
    },
    {
      text: "Quantidade*Código ou Código de barras",
    },
    {
      text: "Quantidade negativa*Código ou Código de barras",
    },
  ],
};

export const scannerInputToolTipInformationsCard: infoToolTipCardOptions = {
  cardTitle: "Informações para leitura",
  cardSubtitle: "Valores aceitos: ",
  cardlistItems: [
   {
      text: "Código ou Código de barras",
    },
    {
      text: "Quantidade*Código ou Código de barras",
    },
    {
      text: "Quantidade negativa*Código ou Código de barras",
    },
  ],
};

export const scannerTableDialogInformations: dialogContentInformations = {
  title: "Exclusão de produto",
  closeText: "Cancelar",
  confirmText: "Excluir",
  content: "Deseja realmente remover este item da lista de leitura?",
};
